// 网站全部文案（纯数据，不依赖 Vue）
// 前端和构建脚本（scripts/postbuild.mjs 生成 SEO 页面）共用这一份
export const SITE_URL = 'https://musesec.com'
export const CONTACT_EMAIL = 'team@musesec.com'
export const TWITTER_HANDLE = '@MuseSec_Team'
export const WECHAT_ID = 'whit28'
export const TWITTER_URL = 'https://x.com/MuseSec_Team'
export const TELEGRAM_HANDLE = '@MuseSec'
export const TELEGRAM_URL = 'https://t.me/MuseSec'

export const zh = {
  nav: {
    links: [
      { id: 'why', label: '为什么' },
      { id: 'coverage', label: '防护范围' },
      { id: 'plans', label: '服务套餐' },
      { id: 'process', label: '合作流程' },
      { id: 'tools', label: '黑U检测' },
      { id: 'about', label: '关于我们' },
    ],
    emergency: '正在被攻击？',
    contact: '免费体检',
    lang: 'EN',
  },
  hero: {
    status: '7×24 应急值守',
    clock: '北京时间',
    eyebrow: '区块链企业 · 资产安全',
    titleA: '没有安全团队？',
    titleB: '我们来当你的',
    titleC: '安全团队',
    sub: '为区块链创业公司提供交易所级别的资产保护，覆盖员工电脑、服务器、钱包和签名流程、链上合约、值班与应急，由一个团队统一负责。',
    cta1: '免费做一次资产安全体检',
    cta2: '正在被攻击？立即联系',
    telemetry: '实时数据',
    stats: [
      { value: '1h', label: '出事后接手响应目标' },
      { value: '6', label: '层链上 + 链下防护' },
      { value: 'LIVE', label: '过去 30 天区块链安全事件，损失约 {loss}', live: true },
    ],
  },
  feed: {
    scanner: 'SCANNER // ACTIVE',
    range: 'CHAIN // TRON',
    title: '实时：USDT 冻结地址',
    source: '数据来自 TRON 链上 USDT 合约黑名单事件',
    status: '已冻结',
    loading: '正在读取链上数据…',
    error: '链上数据暂时读取失败',
    ago: { s: '秒前', m: '分钟前', h: '小时前', d: '天前' },
    sectionTitle: '最近被 Tether 冻结的地址',
  },
  incidents: {
    scanner: 'SCANNER // ACTIVE',
    range: 'SCOPE // MULTI-CHAIN',
    title: '实时：区块链安全事件',
    source: '数据来源：DefiLlama 安全事件库，每小时更新',
    offChain: '链下',
    loading: '正在读取安全事件…',
    error: '安全事件数据暂时读取失败',
    unknown: '原因未披露',
    classes: {
      'Access Control': '权限控制漏洞', 'Protocol Logic': '协议逻辑漏洞', 'Token & Share Accounting': '记账 / 份额计算漏洞',
      'Oracle Manipulation': '预言机操纵', 'Key Compromise': '私钥泄露', 'Frontend & Infrastructure': '前端 / 基础设施被入侵',
      'Input Validation': '输入校验缺失', 'Reentrancy': '重入攻击', 'Social Engineering': '钓鱼 / 社会工程',
      'Bridge & Cross-Chain': '跨链桥漏洞', 'Rugpull': '项目方跑路', 'Governance': '治理攻击', 'Market Manipulation': '市场操纵',
    },
  },
  ticker: ['员工电脑与账号', '服务器与云', '钱包与签名流程', '智能合约与链上监控', '第三方与供应链', '值班与应急响应'],
  why: {
    eyebrow: '为什么',
    title: '大额被盗，多数从链下开始',
    sub: '近几年损失最大的几起事故，攻击者先拿下员工电脑、签名界面、第三方安全产品或运维工具，再转走资金。这些环节在合约审计的范围之外。',
    latest: '最新案例',
    incidents: [
      {
        date: '2026-09', name: 'Bitget', loss: '约 3.9 亿美元', featured: true,
        how: '攻击者利用第三方安全产品的零日漏洞进入内网，冒用员工身份登录能向服务器批量下发任务的管理平台，再横向进入钱包服务器，伪造提币指令绕过风控。整个过程私钥没有泄露，合约也没有漏洞，资金经由内部工具转出。',
        chain: ['第三方安全产品零日漏洞', '冒用员工身份登录管理平台', '批量下发命令，横向进入钱包服务器', '伪造提币指令，绕过风控'],
      },
      { date: '2025-02', name: 'Bybit', loss: '约 15 亿美元', how: '多签使用的签名界面被篡改，签名人看到的和实际签的不是同一笔交易。' },
      { date: '2024-10', name: 'Radiant Capital', loss: '约 5000 万美元', how: '开发者电脑被植入木马，多签成员在正常操作中被骗签。' },
      { date: '2024-05', name: 'DMM Bitcoin', loss: '约 3 亿美元', how: '攻击者伪装成猎头接触钱包服务商员工，借此进入签名系统。' },
    ],
    note: '金额为公开报道的约数。',
  },
  coverage: {
    eyebrow: '防护范围',
    title: '链上 + 链下，一个团队负责到底',
    sub: '从员工电脑到链上合约，覆盖资金可能流失的每个环节。',
    items: [
      { tag: 'LAYER // 01', title: '员工电脑与账号', points: ['电脑装了什么、谁能远程进来，一目了然', '邮箱、交易所、云账号统一开二次验证', '员工离职当天收回所有权限'] },
      { tag: 'LAYER // 02', title: '服务器与云', points: ['对外暴露的端口和后台全部盘点', '关键服务器登录有记录、可追溯', '密钥统一托管，不留在代码和聊天记录里'] },
      { tag: 'LAYER // 03', title: '钱包与签名流程', points: ['一个人被骗，钱也转不走', '大额转账多人审批、签名前核对真实内容', '冷热钱包分层，热钱包只放够用的钱'] },
      { tag: 'LAYER // 04', title: '智能合约与链上监控', points: ['上线前审计，上线后持续盯异常', '大额异动、权限变更第一时间告警', '出现可疑交易可快速暂停'] },
      { tag: 'LAYER // 05', title: '第三方与供应链', points: ['钱包服务商、插件、依赖库逐个评估', '供应商出事时知道自己受不受影响', '对接新服务前先过一遍安全检查'] },
      { tag: 'LAYER // 06', title: '值班与应急响应', points: ['出事后有人在 1 小时内接手', '止损、取证、追踪、对外沟通全程处理', '定期应急演练'] },
    ],
  },
  plans: {
    eyebrow: '服务套餐',
    title: '价格写清楚，小团队也用得起',
    sub: '先做体检，知道钱最可能从哪里丢，再决定要不要长期合作。',
    from: '起',
    recommended: '推荐',
    free: {
      name: '免费安全咨询',
      price: '¥0',
      unit: '30 分钟',
      outcome: '线上聊 30 分钟：说说你的业务、资金怎么管、最担心什么，我们帮你判断现在最该先补哪个洞。不推销，不绑定。',
      points: ['判断当前最大的风险点', '给出 3 条马上能做的改进', '告诉你需不需要付费服务'],
      cta: '预约免费咨询',
    },
    intent: '意向',
    cta: '咨询这个方案',
    more: '了解详情',
    items: [
      { slug: 'security-assessment', name: '资产安全体检', price: '¥3万', unit: '/ 次', outcome: '2–3 周内知道钱最可能从哪里丢，拿到一份按优先级排好的整改清单。', points: ['关键人员访谈', '电脑、服务器、钱包配置检查', '整改清单 + 复盘会'] },
      { name: '安全合伙人订阅', price: '¥2万', unit: '/ 月', outcome: '公司有了一个兼职的安全负责人：每月检查、关键操作陪同、员工培训、出事第一时间有人接手。', points: ['每月固定安全检查', '大额操作、上线前陪同把关', '员工安全培训', '应急响应优先接手'], featured: true },
      { slug: 'wallet-security', name: '钱包与资金架构', price: '¥5万', unit: '/ 项目', outcome: '多签、MPC、冷热钱包和审批流程设计好，一个人被骗也转不走钱。', points: ['资金流转与权限梳理', '多签 / MPC 方案设计', '审批与签名核对流程'] },
      { slug: 'incident-response', name: '应急响应保留', price: '¥5万', unit: '/ 年', outcome: '出事后 1 小时内有人接手：止损、取证、追踪、对外沟通。', points: ['7×24 应急联系通道', '事件处置与取证', '事后复盘报告'] },
      { name: '员工防钓鱼训练', price: '¥1万', unit: '/ 次', outcome: '员工能认出假猎头、假合作方、假客服和恶意签名请求。', points: ['真实案例培训', '模拟钓鱼演练', '演练结果报告'] },
    ],
    note: '以上为起步价，最终价格按团队规模和资产量评估。海外项目可美元结算。',
  },
  process: {
    eyebrow: '合作流程',
    title: '从第一次沟通到长期守护',
    steps: [
      { n: '01', title: '30 分钟免费沟通', text: '了解你的业务、资金规模和最担心的问题。' },
      { n: '02', title: '资产安全体检', text: '2–3 周，找出钱最可能丢的地方，排好优先级。' },
      { n: '03', title: '整改落地', text: '和你的团队一起逐项修复，修完后复查。' },
      { n: '04', title: '持续守护', text: '按月检查、关键操作陪同，出事时第一时间接手。' },
    ],
  },
  tools: {
    eyebrow: '免费工具',
    title: '黑U检测',
    sub: '收款前查一下：对方的 TRON 地址有没有被 Tether 冻结 USDT。',
    placeholder: '输入 TRON 地址（T 开头）',
    button: '检测',
    checking: '检测中…',
    address: '地址',
    risk: '该地址已被 USDT 发行方 Tether 列入黑名单，地址内 USDT 已被冻结，切勿收款或与其交易。',
    safe: '该地址未被 Tether 列入 USDT 黑名单。这不代表资金来源干净，大额收款前仍建议做来源核查。',
    usdt: 'USDT 余额',
    trx: 'TRX 余额',
    tokens: 'TRC20 币种数',
    errEmpty: '请输入检测地址',
    errFormat: '地址格式不对：请输入正确的 T 开头 TRON 地址',
    errFetch: '检测失败，请稍后再试',
    badgeRisk: '已冻结',
    badgeSafe: '未冻结',
  },
  about: {
    eyebrow: '关于我们',
    titleA: '专注区块链',
    titleB: '基础安全',
    text: '我们总部位于深圳，专注区块链企业的基础安全建设与运营。团队成员来自一线交易所安全团队，拥有多年甲方安全建设与应急经验，核心成员具有信息安全、计算机专业硕士背景。从安全建设到日常运营值守，由同一个团队负责。',
    tags: ['安全建设', '安全运营', '合约审计', '应急响应'],
    facts: [
      { k: '成立', v: '2019 年' },
      { k: '总部', v: '中国 · 深圳' },
      { k: '专注', v: '区块链基础安全' },
      { k: '应急', v: '7 × 24' },
    ],
    since: 'EST.',
    verify: '审计报告核验：将报告编号发送到',
  },
  cta: {
    eyebrow: '应急响应 · 安全体检',
    title: '在攻击者发现之前，先把漏洞补上',
    sub: '工作日 24 小时内回复',
    b1: '联系安全团队',
    b2: '正在被攻击？',
  },
  contact: {
    eyebrow: '联系我们',
    title: '聊聊你的情况',
    sub: '留下联系方式和需求，我们会尽快联系你；也可以直接扫码添加微信。',
    name: '称呼 / 公司',
    email: '邮箱',
    phone: '电话 / 微信 / Telegram',
    message: '项目情况与需求',
    submit: '发送',
    errRequired: '请填写称呼、邮箱、电话/微信/Telegram 和需求',
    errEmail: '邮箱格式不对',
    errIm: '请填写有效的电话、微信号或 Telegram',
    sending: '发送中…',
    okBadge: '已发送',
    okTitle: '已收到，我们会尽快联系你',
    okText: '工作日 24 小时内回复。情况紧急请直接扫码加微信。',
    again: '再发一条',
    errSend: '发送失败，请稍后再试，或直接发邮件到 ',
    errRate: '提交太频繁，请稍后再试，或直接发邮件到 ',
    wechat: '扫码加微信咨询',
    address: '深圳市南山区',
    labels: { wechat: '微信', tg: 'TG', email: '邮箱', x: '推特', addr: '地址' },
  },
  emergency: {
    title: '正在被攻击？',
    text: '先做这三件事，然后马上联系我们：',
    steps: ['暂停可疑合约、冻结相关账号和 API Key', '不要关机、不要清理被入侵的电脑，保留证据', '记录可疑交易哈希和时间'],
    telegram: 'Telegram 立即联系',
    email: '紧急邮件',
    wechat: '扫码加微信',
    close: '关闭',
    subject: '【紧急】安全事件求助',
  },
  footer: {
    tagline: '区块链团队的专属安全团队',
    cols: [
      { title: '服务', links: [{ id: 'plans', label: '资产安全体检' }, { id: 'plans', label: '安全合伙人订阅' }, { id: 'plans', label: '应急响应' }] },
      { title: '方案', links: [{ path: '/solutions/', label: '解决方案' }, { path: '/pricing/', label: '价格与套餐' }, { path: '/tools/usdt-check/', label: '黑U检测' }, { path: '/research/', label: '安全研究' }] },
      { title: '公司', links: [{ id: 'about', label: '关于我们' }, { id: 'contact', label: '联系我们' }] },
    ],
    channels: '官方渠道',
    rights: '牧色安全 Musesec 版权所有',
    status: '应急通道在线',
  },
  servicesNav: '服务',
  solutionsNav: '解决方案',
  pricingNav: '价格',
  toolNav: '黑U检测',
  researchNav: '安全研究',
  aboutNav: '关于我们',
  pricingPage: {
    eyebrow: '价格', title: '价格透明，按需选择',
    sub: '先免费聊一次，再决定要不要长期合作。以下均为起步价，最终按团队规模和资产量评估。',
    start: '从这里开始', tiersTitle: '安全合伙人订阅',
    tiersSub: '按月提供兼职安全负责人：定期检查、关键操作陪同、出事第一时间接手。',
    compareTitle: '套餐能力对比', plan: '套餐', include: '包含', optional: '可选',
    optNote: '「可选」表示可加购、单独报价。EDR、WAF 等第三方安全产品的授权费按实际采购另计。',
    addonsTitle: '单项服务', addonsSub: '不想订阅，也可以按项目单独合作。',
    faqTitle: '常见问题', cta: '咨询这个方案', recommended: '推荐', custom: '联系我们', more: '了解详情', swipe: '左右滑动查看全部套餐',
  },
  solutionsPage: {
    eyebrow: '解决方案', title: '按业务类型配置安全防护',
    sub: '按你的业务类型，看看最大的风险在哪，以及我们能提供哪些保护。',
    who: '适合', risks: '主要风险', protects: '我们提供的保护', plan: '推荐方案',
    matrixTitle: '防护能力 × 客户类型', matrixSub: '● 为该类型客户的重点防护项。所有能力都可以按需组合。',
    consult: '免费安全咨询', viewPricing: '查看价格与套餐对比',
  },
  homeTeaser: {
    whoEyebrow: '解决方案', whoTitle: '适合这些团队', whoSub: '交易所、项目方、做市商、OTC、钱包、基金、链上工作室……不同业务，防护重点不同。',
    whoAll: '查看各类型的防护方案',
    priceEyebrow: '服务方案', priceTitle: '从一次免费咨询开始', priceSub: '先弄清楚钱最可能从哪里丢，再决定要不要长期合作。',
    subName: '安全合伙人订阅', subPrice: '¥2万', subUnit: '起 / 月', subDesc: '兼职安全团队：按月检查、关键操作陪同、出事第一时间接手。',
    priceAll: '查看完整价格与套餐对比',
  },
  svc: {
    who: '适合谁', get: '你会得到', how: '怎么做', faq: '常见问题', price: '价格', from: '起',
    cta: '预约免费沟通', more: '查看其他服务', back: '返回首页',
  },
  cases: {
    eyebrow: '客户案例', title: '我们做过的事', sub: '出于保密，客户名称均已匿名。',
    problem: '问题', did: '我们做了什么', result: '结果',
  },
  consent: {
    text: '我们使用统计和广告 Cookie 来了解网站访问情况、衡量推广效果。',
    accept: '接受', reject: '拒绝',
  },
  toast: { copied: '已复制' },
  wechatId: { label: '微信号', copy: '复制', copied: '已复制微信号，打开微信搜索添加即可', failed: '复制失败，请手动输入微信号：' },
}

export const en = {
  nav: {
    links: [
      { id: 'why', label: 'WHY' },
      { id: 'coverage', label: 'COVERAGE' },
      { id: 'plans', label: 'PLANS' },
      { id: 'process', label: 'PROCESS' },
      { id: 'tools', label: 'USDT CHECK' },
      { id: 'about', label: 'ABOUT' },
    ],
    emergency: 'UNDER ATTACK?',
    contact: 'FREE ASSESSMENT',
    lang: '中文',
  },
  hero: {
    status: '24/7 INCIDENT RESPONSE',
    clock: 'UTC+8',
    eyebrow: 'ASSET SECURITY FOR WEB3 TEAMS',
    titleA: 'No security team?',
    titleB: 'We become ',
    titleC: 'your security team',
    sub: 'Exchange-grade asset protection for blockchain startups, covering employee devices, servers, wallets and signing flows, smart contracts, on-call and incident response. One team owns all of it.',
    cta1: 'Get a free security check',
    cta2: 'Under attack? Contact now',
    telemetry: 'LIVE TELEMETRY',
    stats: [
      { value: '1h', label: 'Target time to take over an incident' },
      { value: '6', label: 'Layers of on-chain + off-chain defense' },
      { value: 'LIVE', label: 'Web3 security incidents in the last 30 days, ~{loss} lost', live: true },
    ],
  },
  feed: {
    scanner: 'SCANNER // ACTIVE',
    range: 'CHAIN // TRON',
    title: 'LIVE: FROZEN USDT ADDRESSES',
    source: 'From the USDT contract blacklist events on TRON',
    status: 'FROZEN',
    loading: 'Reading on-chain data…',
    error: 'On-chain data temporarily unavailable',
    ago: { s: 's', m: 'm', h: 'h', d: 'd' },
    sectionTitle: 'Recently frozen by Tether',
  },
  incidents: {
    scanner: 'SCANNER // ACTIVE',
    range: 'SCOPE // MULTI-CHAIN',
    title: 'LIVE: WEB3 SECURITY INCIDENTS',
    source: 'Source: DefiLlama hacks database, updated hourly',
    offChain: 'OFF-CHAIN',
    loading: 'Loading incidents…',
    error: 'Incident data temporarily unavailable',
    unknown: 'Cause undisclosed',
    classes: {
      'Access Control': 'Access control flaw', 'Protocol Logic': 'Protocol logic flaw', 'Token & Share Accounting': 'Accounting flaw',
      'Oracle Manipulation': 'Oracle manipulation', 'Key Compromise': 'Key compromise', 'Frontend & Infrastructure': 'Frontend / infra breach',
      'Input Validation': 'Input validation flaw', 'Reentrancy': 'Reentrancy', 'Social Engineering': 'Phishing / social engineering',
      'Bridge & Cross-Chain': 'Bridge exploit', 'Rugpull': 'Rug pull', 'Governance': 'Governance attack', 'Market Manipulation': 'Market manipulation',
    },
  },
  ticker: ['EMPLOYEE DEVICES', 'SERVERS & CLOUD', 'WALLETS & SIGNING', 'CONTRACTS & ON-CHAIN MONITORING', 'THIRD PARTIES & SUPPLY CHAIN', 'ON-CALL & INCIDENT RESPONSE'],
  why: {
    eyebrow: 'WHY',
    title: 'Most large thefts start off-chain',
    sub: 'In the costliest recent incidents, attackers first took over an employee device, a signing interface, a third-party security product or an ops tool, then moved the funds. None of these are in scope for a contract audit.',
    latest: 'LATEST',
    incidents: [
      {
        date: '2026-09', name: 'Bitget', loss: '~$388M', featured: true,
        how: 'Attackers exploited a zero-day in third-party security products to get inside, used an employee identity to log in to a management platform that pushes tasks to servers, moved laterally to the wallet servers and forged withdrawal commands that bypassed risk controls. Private keys were never exposed and the contracts had no bugs. The funds left through internal tools.',
        chain: ['Zero-day in a third-party security product', 'Employee identity used on the management platform', 'Batch commands, lateral move to wallet servers', 'Forged withdrawals bypass risk controls'],
      },
      { date: '2025-02', name: 'Bybit', loss: '~$1.5B', how: 'The multisig signing interface was tampered with, so signers approved a different transaction from the one they saw.' },
      { date: '2024-10', name: 'Radiant Capital', loss: '~$50M', how: 'Malware on developer devices tricked multisig signers during routine operations.' },
      { date: '2024-05', name: 'DMM Bitcoin', loss: '~$300M', how: 'Attackers posed as recruiters to reach an employee of the wallet provider and got into the signing system.' },
    ],
    note: 'Amounts are approximate, based on public reports.',
  },
  coverage: {
    eyebrow: 'COVERAGE',
    title: 'On-chain + off-chain, one team end to end',
    sub: 'From employee laptops to on-chain contracts, we cover every point where funds could leak.',
    items: [
      { tag: 'LAYER // 01', title: 'Employee devices & accounts', points: ['Know what runs on every laptop and who can get in', '2FA on email, exchange and cloud accounts', 'All access revoked on an employee\'s last day'] },
      { tag: 'LAYER // 02', title: 'Servers & cloud', points: ['Every exposed port and admin panel inventoried', 'Logins to key servers logged and traceable', 'No more keys scattered in code and chats'] },
      { tag: 'LAYER // 03', title: 'Wallets & signing', points: ['One person being phished cannot move the funds', 'Multi-party approval and real-content checks before signing', 'Hot/cold tiers, with hot wallets holding only what is needed'] },
      { tag: 'LAYER // 04', title: 'Contracts & on-chain monitoring', points: ['Audited before launch, watched after', 'Instant alerts on large moves and permission changes', 'Ability to pause fast on suspicious activity'] },
      { tag: 'LAYER // 05', title: 'Third parties & supply chain', points: ['Wallet vendors, plugins and dependencies reviewed', 'Know right away if a vendor incident affects you', 'Security check before onboarding new services'] },
      { tag: 'LAYER // 06', title: 'On-call & incident response', points: ['Someone takes over within 1 hour', 'Containment, forensics, tracing and comms', 'Regular drills to prepare for real incidents'] },
    ],
  },
  plans: {
    eyebrow: 'PLANS',
    title: 'Clear pricing that small teams can afford',
    sub: 'Start with an assessment to find where money is most likely to leak, then decide on a long-term plan.',
    from: 'from',
    recommended: 'RECOMMENDED',
    free: {
      name: 'Free Security Consultation',
      price: '$0',
      unit: '30 min',
      outcome: 'A 30-minute call about your business, how your funds are managed and what worries you most. We help you decide which gap to close first. No pitch, no commitment.',
      points: ['Identify your biggest current risk', 'Three improvements you can make right away', 'An honest answer on whether you need paid help'],
      cta: 'Book a free consultation',
    },
    intent: 'Topic',
    cta: 'Talk to us',
    more: 'Learn more',
    items: [
      { slug: 'security-assessment', name: 'Security Assessment', price: '$5k', unit: '/ project', outcome: 'In 2–3 weeks, know where money is most likely to leak, with a prioritized fix list.', points: ['Key staff interviews', 'Device, server and wallet configuration review', 'Fix list + review session'] },
      { name: 'Security Partner', price: '$3k', unit: '/ month', outcome: 'A fractional head of security: monthly checks, support on critical operations, staff training, first responder on incidents.', points: ['Monthly security review', 'Oversight on large transfers and launches', 'Staff security training', 'Priority incident response'], featured: true },
      { slug: 'wallet-security', name: 'Wallet & Treasury Design', price: '$7k', unit: '/ project', outcome: 'Multisig, MPC, hot/cold wallets and approval flows designed so one compromised person cannot move funds.', points: ['Fund flow and permission mapping', 'Multisig / MPC design', 'Approval and signing verification flow'] },
      { slug: 'incident-response', name: 'Incident Retainer', price: '$7k', unit: '/ year', outcome: 'Someone takes over within 1 hour: containment, forensics, tracing and communications.', points: ['24/7 emergency channel', 'Incident handling and forensics', 'Post-incident report'] },
      { name: 'Anti-Phishing Training', price: '$1.5k', unit: '/ session', outcome: 'Staff can spot fake recruiters, fake partners, fake support and malicious signing requests.', points: ['Real-world case training', 'Phishing simulation', 'Simulation report'] },
    ],
    note: 'Starting prices; final pricing depends on team size and assets under protection.',
  },
  process: {
    eyebrow: 'PROCESS',
    title: 'From first call to ongoing protection',
    steps: [
      { n: '01', title: 'Free 30-min call', text: 'Your business, funds and biggest worries.' },
      { n: '02', title: 'Security assessment', text: '2–3 weeks to find and prioritize where money could leak.' },
      { n: '03', title: 'Fix it together', text: 'We work through the fixes with your team and re-check each one.' },
      { n: '04', title: 'Ongoing protection', text: 'Monthly checks, support on critical operations, first responder on incidents.' },
    ],
  },
  tools: {
    eyebrow: 'FREE TOOL',
    title: 'USDT Blacklist Check',
    sub: 'Before you accept funds: check whether a TRON address has had its USDT frozen by Tether.',
    placeholder: 'Enter a TRON address (starts with T)',
    button: 'CHECK',
    checking: 'Checking…',
    address: 'Address',
    risk: 'This address is on Tether\'s USDT blacklist. Its USDT is frozen — do not accept funds from or trade with it.',
    safe: 'Not on Tether\'s USDT blacklist. This does not prove the funds are clean — verify the source before large transfers.',
    usdt: 'USDT balance',
    trx: 'TRX balance',
    tokens: 'TRC20 tokens',
    errEmpty: 'Please enter an address',
    errFormat: 'Invalid TRON address',
    errFetch: 'Check failed, please try again later',
    badgeRisk: 'FROZEN',
    badgeSafe: 'CLEAR',
  },
  about: {
    eyebrow: 'ABOUT US',
    titleA: 'Focused on blockchain',
    titleB: 'security foundations',
    text: 'Based in Shenzhen, Musesec focuses on building and operating security foundations for blockchain companies. Our team comes from the security teams of leading exchanges, with years of hands-on experience in security engineering and incident response, and graduate degrees in information security and computer science. The same team handles everything from the initial build-out to day-to-day operations and on-call.',
    tags: ['SECURITY ENGINEERING', 'SECURITY OPERATIONS', 'CONTRACT AUDIT', 'INCIDENT RESPONSE'],
    facts: [
      { k: 'FOUNDED', v: '2019' },
      { k: 'HQ', v: 'SHENZHEN' },
      { k: 'FOCUS', v: 'BLOCKCHAIN SECURITY' },
      { k: 'COVERAGE', v: '24 / 7' },
    ],
    since: 'EST.',
    verify: 'To verify an audit report, send its ID to',
  },
  cta: {
    eyebrow: 'INCIDENT RESPONSE · ASSESSMENT',
    title: 'Fix the gaps before attackers find them',
    sub: 'Reply within 24 business hours',
    b1: 'Contact security team',
    b2: 'Under attack?',
  },
  contact: {
    eyebrow: 'CONTACT',
    title: 'Tell us about your situation',
    sub: 'Leave your contact details and needs and we will get back to you soon. You can also reach us on WeChat.',
    name: 'Name / Company',
    email: 'Email',
    phone: 'Phone / WeChat / Telegram',
    message: 'Your project and needs',
    submit: 'SEND',
    errRequired: 'Please fill in name, email, phone/WeChat/Telegram and your needs',
    errEmail: 'Invalid email address',
    errIm: 'Please enter a valid phone, WeChat ID or Telegram',
    sending: 'SENDING…',
    okBadge: 'SENT',
    okTitle: 'Received — we will be in touch soon',
    okText: 'We reply within 24 business hours. For emergencies, reach us on WeChat.',
    again: 'Send another',
    errSend: 'Failed to send. Please try again later or email us at ',
    errRate: 'Too many submissions. Please try again later or email us at ',
    wechat: 'WeChat',
    address: 'Nanshan, Shenzhen, China',
    labels: { wechat: 'WECHAT', tg: 'TG', email: 'EMAIL', x: 'X', addr: 'ADDR' },
  },
  emergency: {
    title: 'Under attack?',
    text: 'Do these three things, then contact us right away:',
    steps: ['Pause suspicious contracts, freeze related accounts and API keys', 'Do not shut down or wipe compromised machines — keep the evidence', 'Record suspicious transaction hashes and times'],
    telegram: 'Message us on Telegram',
    email: 'Emergency email',
    wechat: 'WeChat',
    close: 'Close',
    subject: '[URGENT] Security incident',
  },
  footer: {
    tagline: 'YOUR DEDICATED SECURITY TEAM',
    cols: [
      { title: 'SERVICES', links: [{ id: 'plans', label: 'Security Assessment' }, { id: 'plans', label: 'Security Partner' }, { id: 'plans', label: 'Incident Response' }] },
      { title: 'EXPLORE', links: [{ path: '/solutions/', label: 'Solutions' }, { path: '/pricing/', label: 'Pricing' }, { path: '/tools/usdt-check/', label: 'USDT Blacklist Check' }, { path: '/research/', label: 'Security Research' }] },
      { title: 'COMPANY', links: [{ id: 'about', label: 'About' }, { id: 'contact', label: 'Contact' }] },
    ],
    channels: 'CHANNELS',
    rights: 'Musesec. All rights reserved.',
    status: 'EMERGENCY CHANNEL ONLINE',
  },
  servicesNav: 'SERVICES',
  solutionsNav: 'SOLUTIONS',
  pricingNav: 'PRICING',
  toolNav: 'USDT CHECK',
  researchNav: 'RESEARCH',
  aboutNav: 'ABOUT',
  pricingPage: {
    eyebrow: 'PRICING', title: 'Transparent pricing, pick what you need',
    sub: 'Start with a free call, then decide on a long-term plan. Prices below are starting points; final pricing depends on team size and assets.',
    start: 'Start here', tiersTitle: 'Security Partner subscription',
    tiersSub: 'A fractional security team: monthly checks, support on critical operations, first responder on incidents.',
    compareTitle: 'Plan comparison', plan: 'Plan', include: 'Included', optional: 'Optional',
    optNote: '"Optional" means available as an add-on, quoted separately. Third-party licenses such as EDR or WAF are billed at cost.',
    addonsTitle: 'Individual services', addonsSub: 'Prefer not to subscribe? Engage us per project.',
    faqTitle: 'FAQ', cta: 'Talk to us', recommended: 'RECOMMENDED', custom: 'Contact us', more: 'Learn more', swipe: 'SWIPE TO COMPARE',
  },
  solutionsPage: {
    eyebrow: 'SOLUTIONS', title: 'Security matched to your business type',
    sub: 'Find your business type to see the biggest risks and how we protect you.',
    who: 'For', risks: 'Key risks', protects: 'How we protect you', plan: 'Recommended',
    matrixTitle: 'Capabilities × customer types', matrixSub: '● marks the priority areas for each type. Every capability can be combined as needed.',
    consult: 'Free consultation', viewPricing: 'See pricing & plans',
  },
  homeTeaser: {
    whoEyebrow: 'SOLUTIONS', whoTitle: 'Built for teams like yours', whoSub: 'Exchanges, protocols, market makers, OTC desks, wallets, funds and on-chain studios each need different protection.',
    whoAll: 'See solutions by customer type',
    priceEyebrow: 'PLANS', priceTitle: 'Start with a free consultation', priceSub: 'First find where money could leak, then decide on a long-term plan.',
    subName: 'Security Partner', subPrice: '$3k', subUnit: 'from / month', subDesc: 'A fractional security team: monthly checks, support on critical operations, first responder on incidents.',
    priceAll: 'See full pricing & plan comparison',
  },
  svc: {
    who: 'WHO IT IS FOR', get: 'WHAT YOU GET', how: 'HOW IT WORKS', faq: 'FAQ', price: 'PRICE', from: 'from',
    cta: 'Book a free call', more: 'Other services', back: 'Back to home',
  },
  cases: {
    eyebrow: 'CASE STUDIES', title: 'What we have done', sub: 'Client names are anonymized for confidentiality.',
    problem: 'Problem', did: 'What we did', result: 'Result',
  },
  consent: {
    text: 'We use analytics and advertising cookies to understand site traffic and measure campaigns.',
    accept: 'Accept', reject: 'Decline',
  },
  toast: { copied: 'Copied' },
  wechatId: { label: 'WeChat ID', copy: 'Copy', copied: 'WeChat ID copied — search it in WeChat to add us', failed: 'Copy failed. Please type the WeChat ID: ' },
}
